import { render } from "./select-upload.vue?vue&type=template&id=55315888"
import script from "./select-upload.vue?vue&type=script&lang=js"
export * from "./select-upload.vue?vue&type=script&lang=js"
script.render = render

export default script